import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        userData: {
            userUuid: '',
            userName: '',
            projekttraegerschaftUuid: '',
            projekttraegerschaftName: '',
            rolle: '',
            isFinallyAuthenticated: false
        }
    },
    mutations: {
        setUserData(state, { userData, value }) {
            Vue.set(state.userData, userData, value)
        },
        setIsFinallyAuthenticated(state, isAuthenticated) {
            state.userData.isFinallyAuthenticated = isAuthenticated
        },
        resetUserData(state) {
            state.userData = {
                userUuid: '',
                userName: '',
                projekttraegerschaftUuid: '',
                projekttraegerschaftName: '',
                rolle: '',
                isFinallyAuthenticated: false
            }
        }
    },
    actions: {},
    getters: {
        getUserData: (state) => state.userData,
        getIsFinallyAuthenticated: (state) => state.userData.isFinallyAuthenticated
    },
}
